import { useAuthContext } from '@/providers/AuthProvider';
import { ADMIN_READ_ROLES } from '../lib/adminActionRbac';
import { useAdminAccountQuery } from '../hooks/useAdminAccountsQuery';

/**
 * 관리자 ID → 이름(QA-332 엑셀 다운로드 내역 "요청자"). 본인이면 로그인 정보의 이름, 다른 관리자는 관리자 계정 조회
 * 권한(SUPER_ADMIN·OPS_ADMIN·AUDITOR)이 있을 때만 상세를 불러 이름을 보인다. 알 수 없으면 "—"(ID 원문은 보이지 않는다).
 * withLoginId — QA-515 상품 등록자·수정자처럼 "이름 (로그인 ID)"로 보인다.
 */
export const AdminNameCell = ({
  adminUserId,
  withLoginId = false,
}: {
  adminUserId: string | null | undefined;
  withLoginId?: boolean;
}) => {
  const { currentAdmin } = useAuthContext();
  const isSelf = Boolean(adminUserId && currentAdmin?.adminUserId === adminUserId);
  const canRead = (currentAdmin?.roles ?? []).some((r) => (ADMIN_READ_ROLES as ReadonlyArray<string>).includes(r));
  const other = useAdminAccountQuery(!isSelf && canRead && adminUserId ? adminUserId : null);
  const admin = isSelf ? currentAdmin : other.data;
  const name = admin?.name?.trim();
  const loginId = withLoginId ? admin?.loginId?.trim() : undefined;
  const label = name && loginId ? `${name} (${loginId})` : name || loginId || '—';
  return (
    <span className="whitespace-nowrap" data-testid="admin-name-cell">
      {label}
    </span>
  );
};
